import React from "react";
import moment from "moment";
import "./HeldResort.sass";
import ResortResult from "Interfaces/ResortResultInterface";
import {RequestError} from "Interfaces/RequestError";
import { MvRoomModal } from 'Generic/MvModal';
import { RoomModal } from 'Interfaces/RoomModalInterface';
import ReservationService from 'Services/reservation.service';

// @ts-ignore
import sessionStorage from "store/storages/sessionStorage";

// Constants
import {InitRoomModal} from "Constants/InitInterfaces";

// @ts-ignore
import { LocalizationContext } from 'react-localize';

enum ModalTypes {
  ROOM_MODAL = "room_modal",
};

type HeldResortState = {
  showExpiredResortError: boolean,
  [ModalTypes.ROOM_MODAL]: RoomModal,
  roomModalLoaded: boolean;
  singleRoomInfo: any;
};

type Props = {
  resort: ResortResult;
  deleteHeldResorts: (ReservedInventoryID: number) => void;
  confirmHeldResort: (reservation: ResortResult) => Promise<boolean>;
  openModal: (propCode: string) => void;
  propCode: (propCode: string) => void;
};

class HeldResort extends React.Component<Props, HeldResortState> {
  reservationService: ReservationService;
  constructor(props: Props) {
    super(props);
    this.state = {
      showExpiredResortError: false,
      [ModalTypes.ROOM_MODAL]: Object.assign(InitRoomModal, {}),
      roomModalLoaded: false,
      singleRoomInfo: {}, 
    };
    this.reservationService = new ReservationService();
  }

  propCodeModal(boolean: boolean, propCode: string) {
    this.props.openModal(propCode)
    this.props.propCode(this.props.resort.propertyCode)
  }

  confirmHeldResort(reservation: ResortResult) {
    this.props.confirmHeldResort(reservation)
      .catch((error: RequestError) => {
          this.setState({ showExpiredResortError: true });
      });
  }

    /**
   * if accessibility preferences have been selected,
   * return the accessibility JSX
   */
    accessibilityPrefs() {
      const { localize } = this.context;
      const accessibilityPrefs = this.props.resort.accessibility;
  
      return (
        <div>
          <span>
            {localize("static.content.ayp-accessibility-prefs")}{": "}
          </span>
          {(accessibilityPrefs && accessibilityPrefs.length > 0) ? accessibilityPrefs.map((pref, idx) => {
              const comma = idx + 1 < accessibilityPrefs.length ?
                ", " : "";

              return (
                <span key={pref.value} className="non-label">
                  {pref.name}
                  {comma}
                </span>
              );
            // }) : localize("static.content.ayp-none")}
            }) : localize("None")}
        </div>
      );
    }

    /**
     * if hearing accessible has been selected,
     * return the hearing accessible JSX
     */
    hearingAccessible() {
      const { localize } = this.context;
      const hearingAccessible = this.props.resort.hearingaccessible;
  
      return (
        <div>
          <span>
            {localize("static.content.hearing-accessible")}{": "}
          </span>
          <span className="non-label">
            {/* {hearingAccessible === true ? localize("static.content.ayp-yes") : localize("static.content.ayp-no")} */}
            {hearingAccessible === true ? localize("static.content.ayp-yes") : localize("None")}
          </span>
        </div>
      );
    }

  /**
   * toggle a modal of a given type
   */
    toggleModal = (modalType: ModalTypes): void => {
      if(this.state[modalType].show == true){
      this.setState({roomModalLoaded: false})
      console.log('(*(&&^%^&*(')
      }
      this.setState({
      [modalType]: {
          ...this.state[modalType],
          show: !this.state[modalType].show
      },
      } as any);
  }

  fetchFloorPlan(roomParams:any) {
      this.reservationService.searchRoomInfo(roomParams).then(res => {
          this.setState({
              singleRoomInfo: res,
              roomModalLoaded: true,
          });
      });
  }
  
  render() {
    const { localize } = this.context;
    const { resort } = this.props;
    const checkIn: string = moment(resort.checkIn).format("DD MMM YYYY");
    const checkOut: string = moment(resort.checkOut).format("DD MMM YYYY");

    const segments = JSON.parse(sessionStorage.read(ReservationService.SEGMENTS));

    const handleRoomModal = (resDetails: any) => {
      this.fetchFloorPlan({ 
      segments: segments || ["PTS", "INA", "AP2"],     
      codeRoomPoolCode: [resDetails.roomPoolCode],
      resorts: [resort.propertyCode]})
      this.setState({
        [ModalTypes.ROOM_MODAL]: {
          ...this.state[ModalTypes.ROOM_MODAL],
          room: {} as any,
          show: true,
        },
      })
    }

    return (
      <div className="held-resort">
         <MvRoomModal
              toggle={() => this.toggleModal(ModalTypes.ROOM_MODAL)}
              data={{...this.state[ModalTypes.ROOM_MODAL], ...this.state.singleRoomInfo[0]}}
              fetchLoaded={this.state.roomModalLoaded}
          />
        <div className="held-resort-image two columns">
          <button onClick={(e) => this.propCodeModal(true, resort.propertyCode)} className="img-btn">
            <img className="resort-result-image" src={resort.resortImage} alt={resort.name} />
          </button>
        </div>
        <div className="held-resort-info-container seven columns">
          <div className="held-resort-info-header">
            <button aria-label={resort.name} onClick={(e) => this.propCodeModal(true, resort.propertyCode)} className="rn-btn">
                  {resort.name}
                </button>
                <p className="address-line">
                  {resort.city},{" "}
                  {(resort.state && resort.state != "NO-STATE") ? `${resort.state},` : ""}{" "}
                  {resort.country === "United States" ? "USA" : resort.country}
                </p>
                {
                  resort.display &&
                  <div className="info-wrapper">
                    <p className="info-wrapper">
                      <button aria-label={resort.display} onClick={(e) => this.propCodeModal(true, resort.propertyCode)} className="display-link">
                        {resort.display}
                      </button>
                    </p>
                  </div>
                }
          </div>
          <div className="held-resort-info">
            <div className="seven columns">
              {resort.roomType && <p className="room-name room-type"><span onClick={() => handleRoomModal(resort)} dangerouslySetInnerHTML={{ __html: resort.roomType.description }}></span></p>}
              <div className="info-wrapper">
                <p className="info-wrapper">
                  <span>{localize('static.content.num-of-nights')}</span>: {resort.noOfNight}
                </p>
                <p className="info-wrapper">
                  <span>{localize('static.content.num-of-guests')}</span>: {resort.noOfGuest}
                </p>
              </div>
              <div className="info-wrapper">
                <p className="info-wrapper">
                    {this.accessibilityPrefs()}
                </p>
              </div>
              <div className="info-wrapper">
                <p className="info-wrapper">
                    {this.hearingAccessible()}
                </p>
              </div>
            </div>
            <div className="five columns extra-padding">
              <p className="info-wrapper">
                <span>{localize('static.content.total-points-required')}</span>: {resort.totalPointsRequired}
              </p>
              <p className="info-wrapper">
                <span>{localize('static.content.check-in')}</span>: {checkIn}
              </p>
              <p className="info-wrapper">
                <span>{localize('static.content.check-out')}</span>: {checkOut}
              </p>
            </div>
          </div>
        </div>
        <div className="held-resort-actions three columns">
          <button aria-label={localize('static.content.release-reservation')} onClick={() => this.props.deleteHeldResorts(resort.ReservedInventoryID)} className="mv-button primary">
            {localize('static.content.release-reservation')}
          </button>
          <button aria-label={localize('static.content.select-and-continue')}  onClick={() => this.confirmHeldResort(resort)} className="mv-button primary underline">
            {localize('static.content.select-and-continue')}
          </button>
          {this.state.showExpiredResortError &&
            <p className="held-resort-expired">
              <span>{localize('static.content.hold-expired')}</span>
            </p>
          }
        </div>
      </div>
    );
  }
}

HeldResort.contextType = LocalizationContext;
export default HeldResort;
